// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"17afa7c1","289":"50230384","420":"94b5b80c","508":"bbec0e4b","579":"9bc0ee0f","956":"e8d55783"}[chunkId] + ".chunk.css";
};